import type { ChatMessage, ChatRoom } from "@/api/chat.api";

export function isChatMessageRead(
  message: ChatMessage,
  room: ChatRoom | undefined,
  currentUserId: string | undefined,
): boolean {
  if (!currentUserId || message.sender_id !== currentUserId || !room) return false;
  const messageAt = new Date(message.sent_at ?? message.created_at).getTime();
  const recipients = room.members.filter(
    (member) => member.user_id && member.user_id !== currentUserId,
  );
  return recipients.length > 0 && recipients.every(
    (member) =>
      !!member.last_read_at &&
      new Date(member.last_read_at).getTime() >= messageAt,
  );
}
